import React, { useState, useEffect } from "react";
import { Tab, useTab } from "@mui/base/Tab";
import { TabsList } from "@mui/base/TabsList";
import { TabPanel } from "@mui/base/TabPanel";
import { Tabs } from "@mui/base/Tabs";
import { getAccount, getExpenses } from "./services/api";
import { localizeDates } from "./utils/utils";
import { calculateTotalsByCategory } from "./utils/budgetUtils";
import "./App.css";
import Home from "./pages/Home";
import Expenses from "./pages/Expenses";
import Settings from "./pages/Settings";
import { FaHome, FaDollarSign, FaCog } from "react-icons/fa";

function App() {
  var a = JSON.parse(localStorage.getItem("localAccount"));
  if (!a) {
    a = {
      account: "0",
      categories: ["Rent", "Groceries", "Spending"],
      budget: { monthlyTotal: 1200 },
    };
    localStorage.setItem("localAccount", JSON.stringify(a));
  }

  window.onload = function() {
    const currentDate = new Date();
    let expenses = JSON.parse(localStorage.getItem('expenses')) || [];
    expenses = expenses.filter(expense => {
        const expenseDate = new Date(expense.date);
        const twelveMonthsAgo = new Date(currentDate.setMonth(currentDate.getMonth() - 12));
        return expenseDate >= twelveMonthsAgo;
    });
    localStorage.setItem('expenses', JSON.stringify(expenses));
};

  const [expensesThisMonth, setExpensesThisMonth] = useState([]);
  const [expensesPaginated, setExpensesPaginated] = useState([]);
  const [totalsByCategory, setTotalsByCategory] = useState({});
  const [category, setCategory] = useState("");
  const [categories, setCategories] = useState([]);
  const [amount, setAmount] = useState("0");
  const [description, setDescription] = useState("");
  const [account, setAccount] = useState(a.account);
  const [tempAcct, setTempAcct] = useState(a.account);
  const [budget, setBudget] = useState(0);
  const [tempBud, setTempBud] = useState(0);
  const [month, setMonth] = useState(new Date().getMonth() + 1);
  const [year, setYear] = useState(new Date().getFullYear());

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const account = params.get("account");
    if (account) {
      localStorage.setItem(
        "localAccount",
        JSON.stringify({ account: account })
      );
    }
  }, []);

  useEffect(() => {
    getExpenses(account, new Date().getMonth() + 1, new Date().getFullYear())
      .then((response) => {
        setExpensesThisMonth(localizeDates(response.data.expenses));
      })
      .catch((error) => console.error(error));
  }, [account, expensesPaginated]);

  useEffect(() => {
    getExpenses(account, month, year)
      .then((response) => {
        setExpensesPaginated(localizeDates(response.data.expenses));
        calculateTotalsByCategory(response.data.expenses, setTotalsByCategory);
      })
      .catch((error) => console.error(error));
  }, [account, month, year]);

  useEffect(() => {
    getAccount(account)
      .then((response) => {
        try {
          setBudget(response.budget.monthlyTotal);
          setTempBud(response.budget.monthlyTotal);
          setCategories(response.categories);
        } catch (error) {}
      })
      .catch((error) => console.error(error));
  }, [account]);

  return (
    <div>
      <Tabs defaultValue={1}>
        <TabPanel value={1} className="mb-12">
          <Home
            budget={budget}
            category={category}
            amount={amount}
            description={description}
            setDescription={setDescription}
            categories={categories}
            expensesThisMonth={expensesThisMonth}
            setAmount={setAmount}
            setCategory={setCategory}
            account={account}
            setExpensesThisMonth={setExpensesThisMonth}
            month={month}
            year={year}
            setExpensesPaginated={setExpensesPaginated}
          />
        </TabPanel>
        <TabPanel value={2} className="mb-12">
          <Expenses
            month={month}
            year={year}
            setMonth={setMonth}
            setYear={setYear}
            totalsByCategory={totalsByCategory}
            categories={categories}
            expensesPaginated={expensesPaginated}
            setExpensesPaginated={setExpensesPaginated}
            account={account}
          />
        </TabPanel>
        <TabPanel value={3} className="mb-12">
          <Settings
            tempAcct={tempAcct}
            setTempAcct={setTempAcct}
            setAccount={setAccount}
            tempBud={tempBud}
            setTempBud={setTempBud}
            account={account}
            setBudget={setBudget}
            categories={categories}
            setCategories={setCategories}
            budget={budget}
          />
        </TabPanel>
        <div>
          {" "}
          <TabsList className="bottom-4 border-t-2 bg-gray-100 fixed w-full grid grid-flow-col justify-stretch shadow-lg transform translate-y-4">
            {" "}
            <Tab
              value={1}
              className="m-1 p-3 rounded-md bg-gray-300 hover:bg-gray-400 shadow-md flex justify-center items-center"
            >
              {" "}
              <FaHome className="text-gray-700" />{" "}
            </Tab>{" "}
            <Tab
              value={2}
              className="m-1 p-3 rounded-md bg-gray-300 hover:bg-gray-400 shadow-md flex justify-center items-center"
            >
              {" "}
              <FaDollarSign className="text-gray-700" />{" "}
            </Tab>{" "}
            <Tab
              value={3}
              className="m-1 p-3 rounded-md bg-gray-300 hover:bg-gray-400 shadow-md flex justify-center items-center"
            >
              {" "}
              <FaCog className="text-gray-700" />{" "}
            </Tab>{" "}
          </TabsList>{" "}
        </div>
      </Tabs>
    </div>
  );
}

export default App;
